import { useObjectContext } from '@components/v2/layout/ObjectScreen/hooks/useObjectContext';
import { useWorkspacePadding } from '@components/v2/layout/hooks/useWorkspacePadding';
import { Container } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import useMobileKeyboardDetector from '../../../../../hooks/useMobileKeyboardDetector';
import useOrderEditPageStyles from '../../../styles/useOrderEditPageStyles';
import OrderSummaryTotals from './totals/OrderSummaryTotals';

interface IOrderEditPageSummary {
  isSuggested: boolean;
  isReadOnlyView?: boolean;
}

const OrderEditPageSummary = React.memo(
  ({ isSuggested, isReadOnlyView }: IOrderEditPageSummary) => {
    const { isKeyboardOpen } = useMobileKeyboardDetector();
    const { padding: workspacePadding } = useWorkspacePadding();
    const { isDetailsOpen } = useObjectContext();
    const { classes } = useOrderEditPageStyles({
      isSuggested,
      isKeyboardOpen,
      workspacePadding,
      isDetailsOpen,
    });

    return (
      <>
        <Box className={classes.summaryRoot} key={`${isSuggested}`}>
          <Container
            disableGutters
            style={{
              display: 'flex',
              maxWidth: '100%',
            }}
          >
            <OrderSummaryTotals isSuggested={isSuggested} isReadOnlyView={!!isReadOnlyView} />
          </Container>
        </Box>
      </>
    );
  },
);

export default OrderEditPageSummary;
